import MainLayout from './layout/MainLayout/MainLayout';

function App() {
  return (
    <>
      <MainLayout/>
    </>
  );
}

export default App;
